__turbopack_context__.v({
  "backIcon": "EbdlVa_backIcon",
  "closeIcon": "EbdlVa_closeIcon",
  "cornerButton": "EbdlVa_cornerButton",
  "cornerButtonLeft": "EbdlVa_cornerButtonLeft",
  "cornerButtonRight": "EbdlVa_cornerButtonRight",
  "header": "EbdlVa_header",
  "headerCol": "EbdlVa_headerCol",
  "illustration": "EbdlVa_illustration",
  "title": "EbdlVa_title",
});
